import { render, staticRenderFns } from "./ContactMain.vue?vue&type=template&id=4aca972f&scoped=true"
import script from "./ContactMain.vue?vue&type=script&lang=js"
export * from "./ContactMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aca972f",
  null
  
)

export default component.exports